import "../css/Preloader.css";

function Preloader() {
    return (
        <div className="pre-container">
          {[...Array(5)].map((_, i) => (
            <div className="container" key={i} style={{ animationDelay: `-${i}s` }}>
              {[...Array(12)].map((_, j) => (
                <div
                  className="wrapper"
                  key={j}
                  style={{ transform: `rotate(${(j + 1) * 30}deg)` }}
                >
                  <div className="circle" />
                </div>
              ))}
            </div>
          ))}
        </div>
      );
    };

export default Preloader;
